import React, { Component } from 'react';
import { Header, Card, Image, Icon, Grid, Button, Modal } from 'semantic-ui-react'
import ReactPixel from 'react-facebook-pixel';

import createBrowserHistory from 'history/createBrowserHistory';
const history = createBrowserHistory({ forceRefresh: true });

export default class MainCard extends Component {
    constructor(props) {
        super(props)
    }
    
    sendSelection = () => {
        console.log("obx61 +++++++++++; sendSelection");

        //IF ITS ONE OF THE NEW TEMPLATES ON THE MAIN PAGE SEND TO THE LIST OF OPTIONS
        if (this.props.templateType && this.props.templateSubCategory) {
            //if (this.props.cardObject.templateType && this.props.cardObject.templateSubCategory) {

            var eventProperties = {
                // 'selection': 'template',
                'selection': this.props.templateType,
                templateType: this.props.templateType,
                admin: this.props.admin
            }

            //facebook loggins.. 
            console.log("vcx12t: obx62 ViewContent, itemType / this.props.templateType:" + this.props.templateType);

            if (this.props.admin && this.props.admin === true) {
                console.log("vcx14 its an admin NOT loading pixel view content...");
            } else {

                ReactPixel.track('ViewContent', {
                    content_name: this.props.templateType,
                    // content_name: this.props.cardObject.templateType,
                    content_category: 'Main Tile:template',
                    content_ids: ['template'],
                    content_type: 'product'
                })
            }

            // history.push('/viewCategory/' + this.props.templateSubCategory);
            history.push('/viewCategory/' + this.props.cardObject.templateSubCategory);

        } else if (this.props.templateType) {

            var eventProperties = {
                // 'selection': 'template',
                'selection': this.props.templateType,
                templateType: this.props.templateType,
                admin: this.props.admin
            }

            if (this.props.admin && this.props.admin === true) {
                console.log("vcx14 its an admin NOT loading pixel view content...");
            } else {
                //facebook loggins.. 
                //facebook loggins.. 
                console.log("vcx12: ViewContent, itemType / this.props.templateType:" + this.props.templateType);
                ReactPixel.track('ViewContent', {
                    content_name: this.props.templateType,
                    content_category: 'Main Tile:template',
                    content_ids: ['template'],
                    content_type: 'product'
                })

                window.analytics.track('templateCategorySelected', {
                    'selection': this.props.templateType,
                    templateType: this.props.templateType,
                });
            }

            //old one
            //history.push('/ViewTemplatesByType/' + this.props.templateType);
            // using adset
            history.push('/ViewTemplatesByType/' + this.props.templateType + '/' + this.props.adset);

        } else if (this.props.templateId) {

            var eventProperties = {
                // 'selection': 'template',
                'selection': this.props.ivanDescription,
                templateType: this.props.templateType,
                templateId: this.props.templateId,
                admin: this.props.admin
            }

            window.analytics.track('templateSelected', {
                'selection': this.props.ivanDescription,
                templateType: this.props.templateType,
                templateId: this.props.templateId,
                admin: this.props.admin
            });


            //NEW WAY THAT INCLUDES ADSET
            history.push('/TemplateOrderForm/' + this.props.templateId + '/' + this.props.adset);

        } else {
            this.props.showMainForm(this.props.itemType, this.props.itemTypeDescription, this.props.cardObject);
        }
    }


    render() {
        return (
            <Card onClick={this.sendSelection}>
                {/* <Image src={this.props.image} width={600} height={600} size={this.props.imageSize} /> */}
                <Image src={this.props.image} />
                <Card.Content>
                    <Card.Header>
                        {this.props.itemTypeDescription}
                    </Card.Header>
                    {/* <Card.Meta>
                        <span className='date'>
                            {this.props.shortDescriptions}
                        </span>
                    </Card.Meta> */}
                    <Card.Description>
                        {this.props.fullDescription}
                    </Card.Description>
                </Card.Content>

            </Card>
        )
    }

}


// WEBPACK FOOTER //
// ./src/components/newSite/MainPageCards.js